// Cari kartı bölümlerinin ortak küçük parçaları.
import React from 'react';
import { Box, Typography } from '@mui/material';

export const SectionTitle: React.FC<{ title: string; hint?: string }> = ({ title, hint }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography variant="subtitle1" fontWeight={700}>{title}</Typography>
    {hint && <Typography variant="body2" color="text.secondary">{hint}</Typography>}
  </Box>
);

export const GroupLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography
    variant="overline"
    color="text.secondary"
    sx={{ display: 'block', lineHeight: 1.6, mt: 1.5, mb: 0.5, letterSpacing: '0.06em' }}
  >
    {children}
  </Typography>
);

export const L = 'current.modals.addAccount';
